const drawerWidth = 275;

export const LeftDrawerContainerStyles = {
  width: drawerWidth,
  flexShrink: 0,
  [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
};

export const LeftDrawerSpacerStyles = {
  flexGrow: 1,
};

export const ContactResearchContainerStyles = {
  margin: 2,
  padding: 2,
  borderRadius: 2,
  backgroundColor: '#EFF8FF',
  alignSelf: 'flex-end',
};

export const ContactResearchBoldStyles = {
  fontWeight: 'bold',
};

export const SearchNavContainerStyles = {
  zIndex: (theme: any) => theme.zIndex.drawer + 1,
  height: 72,
  backgroundColor: '#194185',
  justifyContent: 'center',
};

export const SearchNavHamburgerStyles = {
  mr: 1,
};

export const SearchNavLabelStyles = {
  display: { xs: 'none', sm: 'block' },
  fontWeight: 'bold',
  marginLeft: 1,
};

export const SearchNavUserStyles = {
  display: { xs: 'none', sm: 'block' },
  paddingRight: 1,
  color: '#fff'
};
